window.User = {

    login: function(email, password, callback){

        var url = App.webRoot + 'seguro/ajaxValidaLogin';

        var data = {
            usuario: email,
            senha: password
        };

        $.post(url, data).done(function(response){
            response = $.parseJSON(response);
            if(response.status === 'ok') {
                //Should not have this beeing controled over here.
                App.reloadMenu();
            }

            if (callback)
                callback(response);
            
            return false;
        }).fail(function(response){
            // console.log(response);
            alert('Problema inesperado');
        });
    },

    logout: function(){

        var url = App.webRoot + 'seguro/logout';

        $.get(url).done(function(response){

            App.reloadMenu();
            window.location.reload(false);

        }).fail(function(response){
            console.log(response);

            window.location.reload(false);
        });
    },

    //Both createFrom* functions are copy paste from old legacy code D:
    createFromSidebarPf: function() {
        $('#divLoadingContent').show();
        var iProjectId = $('#project_id').val();
        var sNome = $('#inputNomeCompleto').val()
        sNome = sNome.replace(/'/g, ' ');
        $('.js-evbind-registerPf').prop('disabled',true);
       
        $.ajax({
            type: 'POST',
            url: App.webRoot+'criaCadastro',
            dataType: 'json',
            data: {
                ajax: 'sim',
                project_id: $('#inputProjectId').val(),
                tipo: 'PF',
                email: $('#inputEmail').val(),
                senha1: $('#inputSenha1').val(),
                senha2: $('#inputSenha2').val(),
                nome: sNome,
                sexo: $('#inputSexo').val(),
                pais: $('#inputPais').val(),
                estado: $('#estado').val(),
                novo_estado: $('#inputNovoEstado').val(),
                cidade: $('#cidade').val(),
                nova_cidade: $('#inputNovaCidade').val(),
                receive_mail: $('#inputReceiveMail').prop('checked') === true ? 1 : 0,
                receive_notification: $('#inputReceiveNotification').prop('checked') === true ? 1 : 0,
                csrf: $('#inputCsrf').val()
            },
            cache: false,
            timeout: 40000,
            success: function(json) {
                $('#divLoadingContent').hide();
                if (json.retorno=='ok') {
                    if (json.status_user=='waiting') {
                        $('#divConteudo').load(App.webRoot+'projeto/ajaxContribuicaoValidacaoCadastro/'+$('#inputProjectId').val());
                    }
                    if (json.status_user=='active') {
                        App.reloadMenu();
                        // if(ProjectPage.choosenDirectReward != null) {
                        //  var data = [
                        //     {
                        //             id: ProjectPage.choosenDirectReward,
                        //             quantity: 1
                        //         }
                        //     ];

                        //     ProjectPage.chooseRewards($('#inputProjectId').val(), data);    
                        // }
                        Utils.goToSidebarTop();
                        ProjectPage.goToUserEditTab();
                    }
                } else {
                    $('.js-evbind-registerPf').prop('disabled',false);
                    $('#spanMensagemErroGeral').html('Ocorreu um problema ao realizar seu cadastro. Pedimos que tente novamente.');
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                    // Habilita o botão
                    $('.js-evbind-registerPf').prop('disabled',false);
                    switch (textStatus) {
                            case 'timeout'  :   $('#spanMensagemErroGeral').html('<div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><strong><a href=\"#\" onClick=\"CarregaConteudoAjax(sURL,sClass,sLoading)\">Tentar novamente</a></strong></div>');
                            break;
                            default         :   $('#spanMensagemErroGeral').html('<div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><strong><a href=\"#\">Erro: </a></strong>'+errorThrown+'</div>');
                            break;
                        }
                        return false;
                    }
            });
    }, //end of createFromSidebarPf

    createFromSidebarPJ: function() {
        $('#divLoadingContent').show();
        var iProjectId = $('#project_id').val();
        var sRazaoSocial = $('#inputRazaoSocial').val()
        sRazaoSocial = sRazaoSocial.replace(/'/g, ' ');
        $('.js-evbind-registerPJ').prop('disabled',true);

        $.ajax({
                type: 'POST',
                url: App.webRoot+'criaCadastro',
                dataType: 'json',
                data: {
                    ajax: 'sim',
                    project_id: $('#inputProjectId').val(),
                    tipo: 'PJ',
                    email: $('#inputEmail').val(),
                    senha1: $('#inputSenha1').val(),
                    senha2: $('#inputSenha2').val(),
                    razao_social: sRazaoSocial,
                    pais: $('#inputPais').val(),
                    estado: $('#estado').val(),
                    novo_estado: $('#inputNovoEstado').val(),
                    cidade: $('#cidade').val(),
                    nova_cidade: $('#inputNovaCidade').val(),
                    receive_mail: $('#inputReceiveMail').prop('checked') === true ? 1 : 0,
                    receive_notification: $('#inputReceiveNotification').prop('checked') === true ? 1 : 0,
                    csrf: $('#inputCsrf').val()
                },
                cache: false,
                timeout: 10000,
                success: function(json) {
                    $('#divLoadingContent').hide();
                    if (json.retorno=='ok') {
                        if (json.status_user=='waiting') {
                            $('#divConteudo').load(App.webRoot+'projeto/ajaxContribuicaoValidacaoCadastro/'+$('#inputProjectId').val());
                        }
                        if (json.status_user=='active') {
                            App.reloadMenu();
                            // if(ProjectPage.choosenDirectReward != null) {
                            //     var data = [
                            //     {
                            //         id: ProjectPage.choosenDirectReward,
                            //         quantity: 1
                            //     }];

                            //     ProjectPage.chooseRewards($('#inputProjectId').val(), data);    
                            // }
                            Utils.goToSidebarTop();
                            ProjectPage.goToUserEditTab();
                        }
                    } else {
                        $('.js-evbind-registerPJ').prop('disabled',false);
                        $('#spanMensagemErroGeral').html('Ocorreu um problema ao realizar seu cadastro. Pedimos que tente novamente.');
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $('.js-evbind-registerPJ').prop('disabled',false);
                    switch (textStatus) {
                        case 'timeout'  :   $('#spanMensagemErroGeral').html('<div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><strong><a href=\"#\" onClick=\"CarregaConteudoAjax(sURL,sClass,sLoading)\">Tentar novamente</a></strong></div>');
                        break;
                        default         :   $('#spanMensagemErroGeral').html('<div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><strong><a href=\"#\">Erro: </a></strong>'+errorThrown+'</div>');
                        break;
                    }
                    return false;
                }
            });
    }, //end of createFromSidebarPJ
};

// Bind Events

App.bindEvent('login_form', 'submit', function(ev){
    ev.preventDefault();

    var form = $(ev.target);

    var email = $('[name=email]', form).val();
    var password = $('[name=password]', form).val();

    var submit_button = $('[type=submit]',form);

    submit_button.button('loading');

    App.buttons_to_reset.push(submit_button);

    User.login(email, password, function (data) {
        let status = data.status.toString().match(/error/gi);
        if (status) {
            form.find('[type=submit]').button('reset');
            form.find('.alert-login-error').fadeIn(500, function () {
                setTimeout(() => {
                    form.find('.alert-login-error').fadeOut(500);
                }, 4000);
            });
        }
    });

    return false;
});
